import PlaygroundAuthType from "../../../playgroundAuthType";
import sanitizeName from "./sanitizeName";
import OAUTH_NOTE from "./oauthNote";

const getVsCodeInstructions = (playground, bearerToken, mcpServerUrl) => {
  const oauthNote =
    playground.authType === PlaygroundAuthType.OAUTH ? OAUTH_NOTE : "";
  let authInfo = "";
  if (playground.authType === PlaygroundAuthType.BEARER_TOKEN) {
    authInfo = `,
      "headers": {
        "Authorization": "Bearer ${
          bearerToken ? bearerToken : "<YOUR_API_KEY>"
        }"
      }`;
  }
  let uiConfig = "";
  if (playground.authType !== PlaygroundAuthType.BEARER_TOKEN) {
    uiConfig = `
 ## Add via the User Interface

To add the MCP server to your settings:

1. Open the Command Palette (Cmd+Shift+P) and search for "MCP:Add Server...".

1. Then, select "HTTP (HTTP or Server-Sent-Events)".

1. Enter the MCP server URL: \`${mcpServerUrl}\`

1. Enter "${sanitizeName(playground.name)}" as a server ID and press Enter.

1. Choose where to save configuration: Workspace or User Settings.
    `;
  }

  let result = `

${oauthNote}You can add the MCP server to your workspace settings and share it with your team, or add it to your user settings for personal use.

💡 MCP support in VS Code is generally available starting from VS Code 1.102.

Before you begin, ensure you have the latest version of [Visual Studio Code](https://code.visualstudio.com/download) and access to [Github Copilot](https://code.visualstudio.com/docs/copilot/setup).

${uiConfig}

## Add via Configuration File

To add an MCP server to your workspace:

1. Create a \`.vscode/mcp.json\` file in your workspace.

1. Paste the following configuration into the file:


\`\`\`json
{
  "servers": {
    "${sanitizeName(playground.name)}": {
      "url": "${mcpServerUrl}"${authInfo}
    }
  }
}
\`\`\`

## Use the MCP Server

Once you have added an MCP server, you can use the tools it provides in agent mode.

To use MCP tools in agent mode:

1. Open the Chat view (⌃⌘I), and select Agent mode from the dropdown. ![](https://code.visualstudio.com/assets/docs/copilot/chat/mcp-servers/chat-mode-agent.png)

1. Select the Tools button to view the list of available tools. Optionally, select or deselect the tools you want to use.  ![](https://code.visualstudio.com/assets/docs/copilot/chat/mcp-servers/agent-mode-select-tools.png)

1. You can now enter a prompt in the chat input box and notice how tools are automatically invoked as needed. By default, when a tool is invoked, you need to confirm the action before it is run. Use the Continue button dropdown options to automatically confirm the specific tool for the current session, workspace, or all future invocations. ![](https://code.visualstudio.com/assets/docs/copilot/chat/mcp-servers/mcp-tool-confirmation.png)

For further details, see [the official documentation here](https://code.visualstudio.com/docs/copilot/chat/mcp-servers).

`;

  return result;
};

export default getVsCodeInstructions;
